import React, { useEffect, useState } from 'react';
import { useGetDownloadsParticipantsMutation } from 'entities/downloads/participants/api';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { columnConfigDownloadPromo } from 'widgets/downloads/model';
import { downloadNotLoadedParticipants } from 'entities/downloads/participants/api/downloadNotLoadedParticipants';
import { toast } from 'react-toastify';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { mapDownloadParticipantsToTableRenderType } from '../utils';

export const DownloadsShopDotsTable = () => {
  const [downloadParticipantsMethod, { data: downloadParticipants, error: downloadParticipantsError }] =
    useGetDownloadsParticipantsMutation();
  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });

  useEffect(() => {
    downloadParticipantsMethod({
      upload_type: 'activity_participants',
      size: pagination.rowsPerPage,
      page: pagination.page + 1,
    }).then((res) => {
      if ((res as { error: FetchBaseQueryError }).error) {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: Symbol('toastId').toString(),
        });
      }
    });
  }, [pagination]);

  const handleDownloadRow = (idx: number) => {
    downloadNotLoadedParticipants({
      url: downloadParticipants?.items[idx].err_file ?? '',
      fileName: downloadParticipants?.items[idx].file_name ?? '',
    });
  };

  const handleUpdateTable = () => {
    downloadParticipantsMethod({
      upload_type: 'activity_participants',
      size: pagination.rowsPerPage,
      page: 1,
    }).then(() => {
      if (!downloadParticipantsError) {
        toast.success('Данные успешно обновлены', {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error('Произошла ошибка при загрузке данных', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };

  return (
    <DataTableBackendPagination
      title="Акции - Торговые точки"
      data={downloadParticipants ? mapDownloadParticipantsToTableRenderType(downloadParticipants?.items) : []}
      total={downloadParticipants?.total ?? 0}
      pagination={pagination}
      setPagination={setPagination}
      columnConfig={columnConfigDownloadPromo}
      emptyListTitle="Нет загрузок для отображения"
      onDownloadRow={handleDownloadRow}
      onUpdateTable={handleUpdateTable}
      buttonsController
    />
  );
};
